import script from "./RoomAvailabilityPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomAvailabilityPicker.vue?vue&type=script&setup=true&lang=js"

import "./RoomAvailabilityPicker.vue?vue&type=style&index=0&id=05f2131b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f2131b"]])

export default __exports__